// extracted by mini-css-extract-plugin
export default {"pill":"Badge__pill___QnwOm"};